import React from "react";
import "./Hero.css";

const Hero: React.FC = () => {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-container">
        <div className="hero-left">
          <div className="hero-top">
            <div className="hero-logo-container">
              <img
                src="/circle_logo.png"
                alt="The Inner Journey"
                className="hero-logo"
              />
            </div>
            <div className="hero-text-group">
              <h1 className="hero-title">The Inner Journey</h1>
              <h2 className="hero-subtitle">with Arushi Suri</h2>
              <h3 className="hero-role">Counselling Psychologist</h3>
            </div>
          </div>
          <div className="hero-bottom">
            <p className="hero-text">
              "YOU" are a cosmos in yourself, a whole cosmos with explored and
              unexplored galaxies, thousands of stars, visited and unvisited
              planets, all beautiful in their own ways. Just like the universe
              expands every second, you change, grow and become a new individual
              everyday.
            </p>
            <p className="hero-text">
              You have unique inner landscapes; the oceans (your emotions), the
              mountains (the challenges life throws at you), the forests (your
              roots and strengths), the valleys (the ups and down of life), the
              gardens (things, people and places that bring you joy), the rivers
              (your quiet growth), the caves (the unexplored), the crossroads
              (the decisions to be made), the rocky terrains, the foggy areas
              and many more.
            </p>
            <p className="hero-text">
              In your inner journey, together we build a space that feels secure
              and grounded, from here it feels safe to climb the mountains, to
              float through the rivers, to pause and sit outside a cave or
              gently take a step inside when you feel ready and through it all,
              I will be here - facilitating and being the lantern bearer.
            </p>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-logo-container">
            <img
              src="/flowww.svg"
              alt="The Inner Journey"
              className="hero-logo"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
